// import * as _firebase from 'firebase'
// import app from 'firebase/app'
import _firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
// import state from '../store'

const config = {
  apiKey: "AIzaSyAwCWgsXpkr_Bx6W9ZRZ9EB34lf2daREVY",
  authDomain: "taste-together.firebaseapp.com",
  projectId: "taste-together",
  databaseURL: "https://taste-together-default-rtdb.firebaseio.com",
  storageBucket: "taste-together.appspot.com",
  messagingSenderId: "533620532773",
  appId: "1:533620532773:web:f890c121a127fbb7e681cc",
  measurementId: "G-GZ285FGKJP"
};

const _firebaseInstance = _firebase.initializeApp(config)

if (process.env.NODE_ENV !== 'production') {
    _firebase.functions().useFunctionsEmulator('http://localhost:5001');
}

export const firebaseInstance = _firebaseInstance
export const firebase = _firebase



// WEBPACK FOOTER //
// ./src/util/firebase.js